import { makeDraftStore } from "../../../utils/makeDraftStore";

export const { listDrafts, getDraft, saveDraft, deleteDraft } =
  makeDraftStore("membership_create_drafts");
